import { NuxtPage } from 'nuxt/schema';

type Page = {
  name: string;
  path: string;
  componentName: string;
  meta: any;
  children?: Page[];
};

const commonPages: Page[] = [
  {
    name: 'store',
    path: '/butiker/:id',
    componentName: 'StorePage',
    meta: {
      sitemap: {
        contentful: {
          query: {
            content_type: 'storePage',
            select: 'fields.storeId',
          },
          params: {
            storeId: 'fields.storeId',
          },
        },
      },
    },
  },
];

const createRoutes = (pages: Page[]): NuxtPage[] => {
  return pages.map(({ name, meta, componentName, path, children }) => ({
    path,
    name,
    meta,
    children: children ? createRoutes(children) : [],
    component: () => import(`../customPages/${componentName}.vue`),
  }));
};

export const getExtendedPages = async (brand: string) => {
  const { default: brandPages } = await import(`./${brand}-routes.ts`);
  return createRoutes([...brandPages, ...commonPages]);
};
